/* global angular */
( function () {
	'use strict';

	function templateHolder () {
		var templateHolderObj;

		function setTemplate ( templateModel ) {
			templateHolderObj.alter = function ( cb ) {
				cb( templateModel );
			};
		}

		templateHolderObj = {
			'alter'       : angular.noop,
			'setTemplate' : setTemplate
		};

		return templateHolderObj;
	}

	angular
		.module( 'app.templates' )
		.factory( 'templateHolder', templateHolder );
} )();
